import axios from 'axios'
import moment from 'moment'
import jsonp from 'jsonp'
import { url } from './url'

var API_URL = url
export function getCourseList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listCource/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getListXnfzList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listXnfz/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getCourseListNoType(userId,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listCource/"+userId+"?pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getXnfzList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listXnfz/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',
        }).then(res => {
            resolve(res.data);
        })
    });
}

export function listTeam(userId) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listTeam/"+userId
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}

export function getKycgList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listKycg/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getKycgListNoType(userId,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listKycg/"+userId+"?pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getYjhjList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listYjhj/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getXszpList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listXszp/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getQywxList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listQywx/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getHzjlList(userId, type,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listHzjl/"+userId+"?type="+type+"&pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function getHzjlListNoType(userId,pageNum,pageSize) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/listHzjl/"+userId+"?pageNum="+pageNum+"&pageSize="+pageSize
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export function isHasStudent(userId,account,password) {
    return new Promise((resolve, reject) => {
        var url = API_URL + "/common/source/isHasStudent/"+userId+"/"+account+"/"+password
        axios({
            url,
            method: 'get',

        }).then(res => {
            resolve(res.data);
        })
    });
}
export const getResourcelibFilters = () => {
    return new Promise((resolve, reject) => {
        axios({
            url: API_URL + '/resourcelib/filters/' + localStorage.getItem('userId')
        }).then(res => {
            resolve(res.data)
        })
    })
}
export const listResourcelib = query => {
    return new Promise((resolve, reject) => {
        axios({
            url: API_URL + '/resourcelib/pageList/' + localStorage.getItem('userId'),
            params: query
        }).then(res => {
            resolve(res.data)
        })
    })
}